/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPermissionRelationVm
 */
export interface UserPermissionRelationVm {
    /**
     * 
     * @type {string}
     * @memberof UserPermissionRelationVm
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPermissionRelationVm
     */
    permission?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionRelationVm
     */
    byRole?: boolean;
}

export function UserPermissionRelationVmFromJSON(json: any): UserPermissionRelationVm {
    return UserPermissionRelationVmFromJSONTyped(json, false);
}

export function UserPermissionRelationVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionRelationVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
        'byRole': !exists(json, 'byRole') ? undefined : json['byRole'],
    };
}

export function UserPermissionRelationVmToJSON(value?: UserPermissionRelationVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'permission': value.permission,
        'byRole': value.byRole,
    };
}


